module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-4000-with-gift-3c7303f4.png";